/**
 * Alaska: App.js (PWA)
 * Store: Navigation
 * @version 1.0
 */

document.addEventListener("alpine:init", () => {
    Alpine.store("navigation", {
        active: "dashboard",
        base_menu: [
            { icon: "fa-regular fa-house", module: "dashboard", page: "index" },
            { icon: "fa-regular fa-clock", module: "schedule", page: "index" },
            { icon: "fa-regular fa-user", module: "details", page: "index" },
            { icon: "fa-regular fa-file", module: "documents", page: "index" }
        ],

        get menu() {
            const is_admin = Alpine.store("user")?.is_admin;
            const full_menu = [...this.base_menu];

            if (is_admin) {
                full_menu.push({
                    icon: "fa-regular fa-gear",
                    module: "admin",
                    page: "index"
                });
            }

            return full_menu;
        },

        navigate(item) {
            Alpine.nextTick(() => {
                this.active = item.module;
                Alpine.store("state").load(item.module, item.page);
                Alpine.store("state").last_visited_page = item.page;
            });
        }
    });
});